import React from 'react';
import moment from 'moment';
import { Col } from 'reactstrap';
import { Date } from 'components/inputs';

export const DobCol = ({ dob, onChange }) => (
  <Col sm='6'>
    <label htmlFor='dob'>Date of Birth</label>
    <Date
      id='dob' name='dob'
      onChange={ onChange } required
      value={ dob ? moment( dob ) : undefined } 
      maxDate={ moment() }
      minDate={ moment().subtract( 15, 'years' ) } />
  </Col>
);



// WEBPACK FOOTER //
// ./src/pages/base-managment/soldiers/components/Dob.jsx